/* eslint-disable @typescript-eslint/no-unused-vars */
// const { settings } = useAppSelector(selectSession);

import React, { BaseSyntheticEvent, useEffect } from 'react';
import Select, { components, DropdownIndicatorProps } from 'react-select';
import { selectProfile, updateProfile } from '../redux/slices/profileSlice';
import {
	selectSession,
	setEmail,
	setPhone,
} from '../redux/slices/sessionSlice';
import { selectStage, skipStage } from '../redux/slices/stageSlice';
import { useAppDispatch, useAppSelector } from '../redux/hook';

import { DarkButton } from './dark-button';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getCapitalCase } from '../utils';
import Loading from './loading';
import { Modal } from 'react-bootstrap';
import styles from '../styles/datefieldformat.module.css';
import Swal from 'sweetalert2';
import useState from 'react-usestateref';
import { useTranslation } from 'react-i18next';

// const { settings } = useAppSelector(selectSession);
// interface CountrySelect { // Was being used for nationality.
// 	value: number;
// 	label: string;
// }
interface setUDFFieldSelect {
	value: string;
}

interface PhoneCodeSelect {
	value: number | null;
	label: string;
}

interface ResidenceCountrySelect {
	value: number | null;
	label: string;
}

interface NationalityCountrySelect {
	value: number | null;
	label: string;
}

interface IssueCountrySelect {
	value: number | null;
	label: string;
}

const CaretDownIcon = () => {
	return <FontAwesomeIcon icon="caret-down" />;
};

// added type if using typescript
const DropdownIndicator: React.FC<DropdownIndicatorProps> = (props) => {
	return (
		<components.DropdownIndicator {...props}>
			<CaretDownIcon />
		</components.DropdownIndicator>
	);
};

export const GuestProfileForm = ({
	profile,
	countries,
	fields,
	submit,
	docuSubmissionSkipped,
	originalGuestProfile,
	documentsSubmitted,
	currentProfileIndex,
	profileDtl,
}: {
	profile: any;
	countries: any;
	fields: any;
	submit: any;
	docuSubmissionSkipped: any;
	originalGuestProfile: any;
	documentsSubmitted: any;
	currentProfileIndex: any;
	profileDtl: any;
}) => {
	const { t } = useTranslation();
	const dispatch = useAppDispatch();
	const { stages, stage } = useAppSelector(selectStage);
	const { token, reservation, settings, emailPrimary, phonePrimary } =
		useAppSelector(selectSession);
	const [selectedDate, setSelectedDate] = useState<Date | null>(null);
	const formattedDate = selectedDate?.toLocaleDateString('en-GB');
	const [showDatePicker, setShowDatePicker] = useState(false);
	const [isHideLoader, setHideLoader] = useState(false);
	const [isRefreshLoader, setRefreshLoader] = useState(false);
	let invalidInputs = false as boolean;
	const { currentProfile } = useAppSelector(selectProfile);
	const disabledFields =
		currentProfileIndex === 0 ? ['firstName', 'lastName'] : [];
	const [lazyLoad, setLazyLoad, lazyLoadRef] = useState(false);
	const fieldsToHandle: string[] = fields.map(
		(x: { fieldCode: any }) => x.fieldCode
	);
	const { isPostComplete: isProfilePostComplete } =
		useAppSelector(selectProfile);
	const skipAccompanyDocument =
		settings?.find(
			(setting: any) =>
				setting.parameterName === 'SkipAccompanyDetails' &&
				setting.parameterValue === 'true'
		) ?? false;
	const skipChildDocument =
		settings?.find(
			(setting: any) =>
				setting.parameterName === 'SkipChildDetails' &&
				setting.parameterValue === 'true'
		) ?? false;

	const fieldAlias = {
		title: 'nameTitle',
		firstName: docuSubmissionSkipped ? 'firstName' : 'givenName',
		lastName: docuSubmissionSkipped ? 'lastName' : 'surname',
		documentNumber: 'documentNumber',
		documentType: 'documentClassCode',
		nationality: 'nationalityCode',
		nationalityCountry: 'nationality',
		issueCountry: 'issueCountry',
		issueDate: 'issueDate',
		expiryDate: 'expiryDate',
		countryOfResidence: 'countryOfResidence',
		email: 'email',
		phoneNo_Res: 'phoneNo_Res',
		carPlateNumber: 'carPlateNumber',
		address: 'address',
		city: 'city',
		postalCode: 'postalCode',
		phone: 'postalCode1',
		visaOrResidencePermitNo: 'visaOrResidencePermitNo',
		PlaceofEntry: 'placeofEntry',
		DateofEntry: 'dateofEntry',
		mothersName: 'mothersName',
		dateOfBirth: 'dateOfBirth',
		dateofBirthDT: 'dateofBirthDT',
		birthPlace: 'birthPlace',
		placeOfIssue: 'placeOfIssue',
		placeOfBirth: 'placeOfBirth',
	} as any;

	const placeholderMap = {
		firstName: '',
		lastName: '',
		email: '',
		phoneNo_Res: '',
	} as any;

	const vars = {} as any;
	const setters = {} as any;
	const refs = {} as any;
	const handlers = {} as any;
	const errorfields = [] as any;
	const invalidListfields = [] as any;

	// const [vars, setVars] = useState({});
	// const [setters, setSetters] = useState();
	// const [refs, setRefs] = useState('');
	// const [handlers, setHandlers] = useState();

	const getInitialState = (
		element: any,
		profile: any,
		profileDtl: any,
		fieldAlias: any
	) => {
		if (profile !== null && profile !== undefined) {
			return (
				profileDtl !== null && profileDtl != undefined
					? (profile[fieldAlias[element]] === null ||
					  profile[fieldAlias[element]] === undefined
							? profileDtl[element] === null ||
							  profileDtl[element] === undefined
								? ''
								: profileDtl[element]
							: profile[fieldAlias[element]] === null ||
							  profile[fieldAlias[element]] === undefined
							? ''
							: profile[fieldAlias[element]]) ?? ''
					: profile[fieldAlias[element]] ?? ''
			)?.replace(/\+/g, '');
		} else {
			// Default value when profile is null or undefined
			return '';
		}
	};

	fieldsToHandle.map((element) => {
		[vars[element], setters[element], refs[element]] = useState(
			getInitialState(element, profile, profileDtl, fieldAlias)
		);

		handlers[element] = (val: any) => {
			setters[element]((prevState: any) =>
				element !== 'email' && element !== 'carPlateNumber'
					? getCapitalCase(val)
					: val === null || val === undefined
					? ''
					: val
			);
		};
	});

	useEffect(() => {
		fieldsToHandle.map((element) => {
			if (profile !== null && profile !== undefined) {
				handlers[element] = (val: any) => {
					setters[element]((prevState: any) =>
						element !== 'email'
							? getCapitalCase(val)
							: val === null || val === undefined
							? ''
							: val
					);
				};
				const newVal = getInitialState(
					element,
					profile,
					profileDtl,
					fieldAlias
				);
				if (
					element === 'email' &&
					(newVal === null || newVal === undefined || newVal === '')
				) {
					// Don't set refs[element].current
				} else if (
					element === 'phoneNo_Res' &&
					(newVal === null || newVal === undefined || newVal === '')
				) {
					// Don't set refs[element].current
				} else if (
					element === 'countryOfResidence' &&
					(newVal === null || newVal === undefined || newVal === '')
				) {
					refs[element].current = 0;
					vars[element] = 0;
				} else {
					refs[element].current = newVal;
					vars[element] = newVal;
				}
			} else {
				handlers[element] = (val: any) => {
					setters[element]((prevState: any) =>
						element !== 'email'
							? getCapitalCase(val)
							: val === null || val === undefined
							? ''
							: val
					);
				};
				if (element !== 'email' && element !== 'phoneNo_Res') {
					refs[element].current = '';
					vars[element] = '';
				}
				if (element === 'countryOfResidence') {
					refs[element].current = 1;
					vars[element] = 1;
				}
			}
		});
	}, [profile]);

	useEffect(() => {
		if (isProfilePostComplete === true) {
			setRefreshLoader(false);
			setHideLoader(false);
		}
	}, [isProfilePostComplete]);

	const [UDFFieldList, setUDFFieldSelect, UDFFieldListRef] = useState<
		setUDFFieldSelect[]
	>([]);

	// const [phoneCodeLabel, setPhoneCodeLabel, phoneCodeLabelRef] =
	// 	useState<any>(null);

	// const [phoneCodeSelect, setPhoneCodeSelect, phoneCodeRef] = useState<
	// 	PhoneCodeSelect[]
	// >([]);

	const [
		residenceCountryLabel,
		setResidenceCountryLabel,
		residenceCountryLabelRef,
	] = useState<any>(null);

	const [
		nationalityCountryLabel,
		setNationalityCountryLabel,
		nationalityCountryLabelRef,
	] = useState<any>(null);

	const [issueCountryLabel, setIssueCountryLabel, issueCountryLabelRef] =
		useState<any>(null);

	const [
		residenceCountrySelect,
		setResidenceCountrySelect,
		residenceCountryRef,
	] = useState<ResidenceCountrySelect[]>([]);

	const [
		nationalityCountrySelect,
		setNationalityCountrySelect,
		nationalityCountryRef,
	] = useState<NationalityCountrySelect[]>([]);

	const [issueCountrySelect, setIssueCountrySelect, issueCountryRef] = useState<
		IssueCountrySelect[]
	>([]);

	const handleSkip = () => {
		dispatch(
			skipStage({
				token: token,
				stageID: stage?.stepID,
				ReservationID: reservation?.ReservationID,
				type: 'checkin',
				confirmationNo: reservation?.PmsConfirmationNo,
				stages: stages,
			})
		);
	};
	const getDateFormatted = (date: any) => {
		if (date !== null && date !== undefined && date !== '') {
			console.log('date===>>>' + date);
			const ddt = new Date(Date.parse(date));
			//handlers['dateOfBirth'](date);
			//console.log('date===>>>>>' + handlers['dateOfBirth'](date));
			return ddt;
		} else {
			return null;
		}
	};

	useEffect(() => {
		// const specificFieldList = [];
		// const specificRows = Object.values(fields).filter(row => row.IsUDF);

		for (const field in fields) {
			if (fields[field].isUDF) {
				/* eslint-disable no-debugger */
				//debugger;
				/* eslint-enable no-debugger */
				setUDFFieldSelect([
					...(UDFFieldListRef?.current ?? {}),
					{
						value: fields[field].fieldCode,
					},
				]);
			}
		}

		setResidenceCountrySelect([]);
		for (const country in countries) {
			setResidenceCountrySelect([
				...(residenceCountryRef?.current ?? {}),
				{
					value: countries[country].CountryID,
					label: `${countries[country].CountryCode} - ${countries[country].CountryName}`,
				},
			]);

			setNationalityCountrySelect([
				...(nationalityCountryRef?.current ?? {}),
				{
					value: countries[country].CountryID,
					label: `${countries[country].CountryCode} - ${countries[country].CountryName}`,
				},
			]);
			setIssueCountrySelect([
				...(issueCountryRef?.current ?? {}),
				{
					value: countries[country].CountryID,
					label: `${countries[country].CountryCode} - ${countries[country].CountryName}`,
				},
			]);
			// setPhoneCodeSelect([
			// 	...(phoneCodeRef?.current ?? {}),
			// 	{
			// 		value: countries[country].CountryID,
			// 		label: `${countries[country].PhoneCode}`,
			// 	},
			// ]);
		}

		const countryOfResidence = countries.find(
			(country: any) =>
				country.CountryCode === profile?.issuingStateCode ||
				country.CountryCode === profile?.countryOfResidence
		);

		if (countryOfResidence) {
			if (
				handlers['countryOfResidence'] !== null &&
				handlers['countryOfResidence'] !== undefined
			) {
				handlers['countryOfResidence'](countryOfResidence?.CountryID);
				setResidenceCountryLabel(
					`${countryOfResidence?.CountryCode} - ${countryOfResidence?.CountryName}`
				);
			}
		}

		const nationality = countries.find(
			(country: any) => country.CountryCode === profile?.nationalityCode
		);

		if (nationality) {
			if (
				handlers['nationality'] !== null &&
				handlers['nationality'] !== undefined
			) {
				handlers['nationality'](nationality?.CountryID);
				setNationalityCountryLabel(
					`${nationality?.CountryCode} - ${nationality?.CountryName}`
				);
			}
		}

		const issueCountry = countries.find(
			(country: any) =>
				country.CountryCode === profile?.issuingStateCode ||
				country.CountryCode === profile?.countryOfResidence
		);

		if (issueCountry) {
			if (
				handlers['issueCountry'] !== null &&
				handlers['issueCountry'] !== undefined
			) {
				handlers['issueCountry'](issueCountry?.CountryID);
				setIssueCountryLabel(
					`${issueCountry?.CountryCode} - ${issueCountry?.CountryName}`
				);
			}
		}

		if (currentProfileIndex === 0) {
			dispatch(setEmail(''));
			dispatch(setPhone(''));
		}

		let field = fields.find((f: any) => f.code === 'email');

		if (
			(field === null || field === '' || field === undefined) &&
			emailPrimary != null &&
			emailPrimary !== undefined &&
			emailPrimary !== ''
		) {
			//handlers['email'](localStorage.getItem('email_primary'));
			handlers['email'](emailPrimary);
		}

		field = fields.find((f: any) => f.code === 'phoneNo_Res');

		if (
			(field !== null || field === '' || field === undefined) &&
			phonePrimary != null &&
			phonePrimary !== undefined &&
			phonePrimary !== ''
		) {
			//handlers['phoneNo_Res'](localStorage.getItem('phone_primary'));
			handlers['phoneNo_Res'](phonePrimary);
		}
		setLazyLoad(true);
		setHideLoader(false);
	}, []);

	const checkMandatory = async () => {
		let hasInvalidInputs = false;

		for (const field of fields) {
			const { fieldName, fieldCode, isMandatory, validationType } = field;
			const element = field.fieldCode;
			if (element !== undefined && element !== null) {
				const fieldElement = document.getElementById(
					element.toString()
				) as HTMLInputElement;

				if (fieldElement && field.fieldType === 'Input') {
					if (
						(!fieldElement.value || fieldElement.value.trim() === '') &&
						isMandatory
					) {
						console.log('fieldElement.value');
						invalidListfields.push(fieldName);
						errorfields.push(fieldName);
						hasInvalidInputs = true;
					} else if (fieldElement.value) {
						if (
							validationType === 'alphabet' &&
							!alphabet(fieldElement.value)
						) {
							invalidListfields.push(fieldName);
							errorfields.push(fieldName);
							hasInvalidInputs = true;
						} else if (
							validationType === 'numeric' &&
							!numeric(fieldElement.value)
						) {
							invalidListfields.push(fieldName);
							errorfields.push(fieldName);
							hasInvalidInputs = true;
						} else if (
							validationType === 'alphanumeric' &&
							!alphanumeric(fieldElement.value)
						) {
							invalidListfields.push(fieldName);
							errorfields.push(fieldName);
							hasInvalidInputs = true;
						} else if (
							validationType === 'alphanumericspecial' &&
							!alphanumericspecial(fieldElement.value)
						) {
							invalidListfields.push(fieldName);
							errorfields.push(fieldName);
							hasInvalidInputs = true;
						}
					}
					// Additional operations with the fieldElement if needed
				} else if (fieldElement && field.fieldType.toLowerCase() === 'date') {
					if (
						(!fieldElement.value || fieldElement.value.trim() === '') &&
						isMandatory
					) {
						invalidListfields.push(fieldName);
						errorfields.push(fieldName);
						hasInvalidInputs = true;
					}
				} else if (
					fieldElement &&
					field.fieldType.toLowerCase() === 'dropdown'
				) {
					if (
						(!residenceCountryLabel || residenceCountryLabel.trim() === '') &&
						isMandatory &&
						fieldCode === 'countryOfResidence'
					) {
						invalidListfields.push(fieldName);
						errorfields.push(fieldName);
						hasInvalidInputs = true;
					}

					if (
						(!nationalityCountryLabel ||
							nationalityCountryLabel.trim() === '') &&
						isMandatory &&
						fieldCode === 'nationality'
					) {
						invalidListfields.push(fieldName);
						errorfields.push(fieldName);
						hasInvalidInputs = true;
					}

					if (
						(!issueCountryLabel || issueCountryLabel.trim() === '') &&
						isMandatory &&
						fieldCode === 'issueCountry'
					) {
						invalidListfields.push(fieldName);
						errorfields.push(fieldName);
						hasInvalidInputs = true;
					}

					if (
						nationalityCountryLabel &&
						fieldCode === 'nationality' &&
						nationalityCountryLabel.trim().includes('United Kingdom')
					) {
						const _placeofEntry = document.getElementById(
							'placeofEntry'
						) as HTMLInputElement;
						const _dateofEntry = document.getElementById(
							'dateofEntry'
						) as HTMLInputElement;
						if (
							_placeofEntry?.value === '' ||
							_placeofEntry?.value === null ||
							_placeofEntry?.value === undefined
						) {
							invalidListfields.push('Place of Entry');
							errorfields.push('Place of Entry');
							hasInvalidInputs = true;
						}
						if (
							_dateofEntry?.value === '' ||
							_dateofEntry?.value === null ||
							_dateofEntry?.value === undefined
						) {
							invalidListfields.push('Date of Entry');
							errorfields.push('Date of Entry');
							hasInvalidInputs = true;
						}
					}
				}
			}
		}

		if (hasInvalidInputs === false) {
			const email = document.getElementById('email') as HTMLInputElement;
			const phone = document.getElementById('phoneNo_Res') as HTMLInputElement;
			if (
				email?.value != '' &&
				email?.value != null &&
				email?.value != undefined &&
				!validateEmail(email?.value)
			) {
				hasInvalidInputs = true;
				errorfields.push('Email');
			}
			if (
				phone?.value != '' &&
				phone?.value != null &&
				phone?.value != undefined &&
				!validatePhoneNumber(phone?.value)
			) {
				hasInvalidInputs = true;
				errorfields.push('Mobile Number');
			}
		}

		invalidInputs = hasInvalidInputs;
	};

	// useEffect(() => {
	// 	/* eslint-disable no-debugger */
	// 	debugger;
	// 	console.log('handleSubmit--');
	// 	/* eslint-enable no-debugger */
	// 	const profileData = {
	// 		vars,
	// 		profileDocuments: [],
	// 	};

	// 	if (!invalidInputs && isSubmitData) {
	// 		submit(profileData);
	// 	}
	// }, [invalidInputs, isSubmitData]);

	const handleSubmit = async (event: any) => {
		await checkMandatory();
		setHideLoader(false);
		/* eslint-disable no-debugger */
		console.log('inside handleSubmit' + invalidInputs);

		/* eslint-enable no-debugger */
		//invalidInputs = true;
		//console.log(UDFFieldListRef?.current);
		const profileData = {
			vars,
			UDFFieldList,
			profileDocuments: [],
		};
		if (!invalidInputs) {
			if (currentProfileIndex === 0) {
				// localStorage.setItem('email_primary', vars['email']);
				// localStorage.setItem('phone_primary', vars['phoneNo_Res']);
				dispatch(setEmail(vars['email']));
				dispatch(setPhone(vars['phoneNo_Res']));
			}
			setRefreshLoader(true);
			//dispatch(updateProfile({ dto: profileData }));
			submit(profileData);
			setHideLoader(true);
		} else {
			const errorMessage =
				errorfields && errorfields.length > 1
					? errorfields === 'Mobile Number'
						? `Please provide valid ${errorField} without special characters.`
						: `Please ensure ${errorfields.join(',')}  are valid.`
					: errorfields.length == 1
					? `Please ensure ${errorfields.join(',')}  is valid.`
					: null;

			Swal.fire({
				title: errorMessage ? '' : 'Invalid details',
				text: errorMessage ?? '',
				icon: 'error',
			}).then(function () {
				console.log('invalid inputs');
				setHideLoader(true);
				//setButtonLoading(false);
			});
		}
	};

	const validateEmail = (email: any) => {
		// Use a regular expression to validate email format
		const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
		const isValid = emailRegex.test(email);
		return isValid;
	};

	const validatePhoneNumber = (phoneNumber: any) => {
		// Use a regular expression to validate phone number format
		// const phoneRegex = /^\d+$/;
		// const isValid = phoneRegex.test(phoneNumber);
		const phoneRegex = /^\+?\d+$/; // allows optional + at the start
		const isValid = phoneRegex.test(phoneNumber);
		return isValid;
	};

	const numeric = (_Number: any) => {
		const _Regex = /^\d+$/;
		const isValid = _Regex.test(_Number);
		return isValid;
	};
	const alphabet = (_string: any) => {
		const _Regex = /^[ A-Za-z]+$/; //keep space to allow for space in the validation
		const isValid = _Regex.test(_string);
		return isValid;
	};
	const alphanumeric = (_string: any) => {
		const _Regex = /^[ A-Za-z0-9]*$/; //keep space to allow for space in the validation
		const isValid = _Regex.test(_string);
		return isValid;
	};
	const alphanumericspecial = (_string: any) => {
		const _Regex = /^[ A-Za-z0-9_@./#&+<>*!-]*$/; //keep space to allow for space in the validation
		const isValid = _Regex.test(_string);
		return isValid;
	};

	const [inputValue1, setInputValue] = useState('');
	const [validationError, setValidationError] = useState<string | undefined>(
		undefined
	);

	const [validationErrorEU, setValidationErrorEU] = useState<boolean>(false);

	const [errorField, setErrorField] = useState('');

	const validateInput = (
		value: string,
		field: string,
		IsMandatory: boolean,
		validationType: string,
		validationMessage: string,
		fieldType: string,
		isUDFField: boolean
	) => {
		const fieldElement = document.getElementById(field) as HTMLInputElement;
		const inputElement = document.getElementById(field);
		inputElement?.classList.remove('is-invalid');
		if (
			(!fieldElement.value || fieldElement.value.trim() === '') &&
			IsMandatory
		) {
			setErrorField(field);

			return 'Field cannot be empty';
		} else if (
			fieldElement.value &&
			fieldType.toLocaleLowerCase() === 'input'
		) {
			if (
				field === 'email' &&
				fieldElement.value != '' &&
				fieldElement.value != null &&
				fieldElement.value != undefined &&
				!validateEmail(fieldElement.value)
			) {
				setErrorField(field);

				if (inputElement) {
					inputElement.classList.add('is-invalid');
				}
				return 'Invalid Email ID';
			} else if (
				validationType === 'alphabet' &&
				!alphabet(fieldElement.value)
			) {
				setErrorField(field);
				if (inputElement) {
					inputElement.classList.add('is-invalid');
				}
				return validationMessage;
			} else if (validationType === 'numeric' && !numeric(fieldElement.value)) {
				setErrorField(field);

				if (inputElement) {
					inputElement.classList.add('is-invalid');
				}
				return validationMessage;
			} else if (
				validationType === 'alphanumeric' &&
				!alphanumeric(fieldElement.value)
			) {
				setErrorField(field);

				if (inputElement) {
					inputElement.classList.add('is-invalid');
				}
				return validationMessage;
			} else if (
				validationType === 'alphanumericspecial' &&
				!alphanumericspecial(fieldElement.value)
			) {
				setErrorField(field);

				if (inputElement) {
					inputElement.classList.add('is-invalid');
				}
				return validationMessage;
			}
		} else if (
			fieldElement.value &&
			fieldType.toLocaleLowerCase() === 'date' &&
			isValidDateFormat(fieldElement.value)
		) {
			setErrorField(field);

			if (inputElement) {
				inputElement.classList.add('is-invalid');
			}
			return validationMessage;
		}
		return undefined;
	};

	const validateDate = (
		value: any,
		field: string,
		isMandatory: boolean,
		validationType: string,
		validationMessage: string,
		fieldType: string
	) => {
		/* eslint-disable no-debugger */
		// debugger;
		/* eslint-enable no-debugger */
		const fieldElement = document.getElementById(field) as HTMLInputElement;

		const fieldElementNationality = document.getElementById(
			'nationality'
		) as HTMLInputElement;

		const dateValue = value?.toLocaleDateString('en-US');

		if ((!dateValue || dateValue.trim() === '') && isMandatory) {
			setErrorField(field);
			return 'Field cannot be empty';
		} else if (
			dateValue &&
			fieldType.toLocaleLowerCase() === 'date' &&
			!isValidDateFormat(dateValue)
		) {
			setErrorField(field);
			setSelectedDate(null);
			return validationMessage;
		} else if (
			!dateValue &&
			fieldElementNationality?.value &&
			fieldElementNationality?.value.trim().includes('United Kingdom') &&
			fieldType.toLocaleLowerCase() === 'date'
		) {
			setErrorField(field);
			setSelectedDate(null);
			return validationMessage;
		}
		return undefined;
	};

	const isValidDateFormat = (dateString: string) => {
		const dateFormatPattern =
			/(0?[1-9]|1[012])\/(0?[1-9]|[12][0-9]|3[01])\/\d{4}/;
		return dateFormatPattern.test(dateString);
	};

	const handleDatePickerChange = (
		date: Date | null,
		elementName: string,
		isFieldMandatory: boolean,
		validationType: string,
		Message: string,
		fieldType: string
	) => {
		/* eslint-disable no-debugger */
		// debugger;
		/* eslint-enable no-debugger */
		setSelectedDate(date);
		const value = date;
		const error = validateDate(
			value,
			elementName,
			isFieldMandatory,
			validationType,
			Message,
			fieldType
		);
		setValidationError(error);
		if (!error) {
			handlers[elementName](date);
		}
	};

	const handleCalendarIconClick = () => {
		setShowDatePicker(!showDatePicker);
	};

	const handleSelectChange = (elementName: string, selectedOption: any) => {
		handlers[elementName](selectedOption?.value);

		setValidationErrorEU(false);
		let hasInvalidInputs = false;

		if (elementName === 'nationality') {
			setNationalityCountryLabel(selectedOption?.label);
		} else if (elementName === 'countryOfResidence') {
			setResidenceCountryLabel(selectedOption?.label);
		} else if (elementName === 'issueCountry') {
			setIssueCountryLabel(selectedOption?.label);
		}

		if (
			selectedOption?.label &&
			elementName === 'nationality' &&
			selectedOption?.label.trim().includes('United Kingdom')
		) {
			const _placeofEntry = document.getElementById(
				'placeofEntry'
			) as HTMLInputElement;

			const _dateofEntry = document.getElementById(
				'dateofEntry'
			) as HTMLInputElement;

			if (
				_placeofEntry?.value === '' ||
				_placeofEntry?.value === null ||
				_placeofEntry?.value === undefined
			) {
				invalidListfields.push('Place of Entry');
				errorfields.push('Place of Entry');
				hasInvalidInputs = true;

				setErrorField('placeofEntry');
				setValidationErrorEU(true);
			}

			if (
				_dateofEntry?.value === '' ||
				_dateofEntry?.value === null ||
				_dateofEntry?.value === undefined
			) {
				invalidListfields.push('Date of Entry');
				errorfields.push('Date of Entry');
				hasInvalidInputs = true;

				setErrorField('dateofEntry');
				setValidationErrorEU(true);
			}
		}

		const countryOfResidence = countries.find(
			(country: any) => country.CountryID === selectedOption?.value
		);

		// if (selectedOption?.label && elementName === 'countryOfResidence') {
		// 	if (countryOfResidence) {
		// 		handlers['phoneCode'](countryOfResidence?.PhoneCode);
		// 		setPhoneCodeLabel(`${countryOfResidence?.PhoneCode}`);
		// 	}
		// }
		//setinvalidInputs(hasInvalidInputs);
		invalidInputs = hasInvalidInputs;
	};

	const format = (mask: string, number: string) => {
		const s = '' + number;
		let r = '';
		for (let im = 0, is = 0; im < mask.length && is < s.length; im++) {
			r += mask.charAt(im) == 'X' ? s.charAt(is++) : mask.charAt(im);
		}
		console.log(r);
		return r;
	};

	const handlePhoneCodeSelectChange = (
		elementName: string,
		selectedOption: any
	) => {
		const countryOfResidence = countries.find(
			(country: any) => country.CountryID === selectedOption?.value
		);

		if (selectedOption?.label && elementName === 'phoneNo_Res') {
			if (countryOfResidence) {
				handlers['countryOfResidence'](countryOfResidence?.CountryID);
				setResidenceCountryLabel(
					`${countryOfResidence?.CountryCode} - ${countryOfResidence?.CountryName}`
				);
			}
		}
	};

	// checkEmailAndPhone();
	//checkMandatory();

	return lazyLoadRef?.current === false ? (
		<Loading />
	) : (
		<div
			style={{
				marginBottom: '100px',
			}}>
			<form className="row pt-2 px-3 mx-auto" style={{ maxWidth: '1200px' }}>
				{fields.map(
					(field: {
						fieldName: any;
						fieldDesc: any;
						fieldCode: any;
						fieldType: any;
						isMandatory: any;
						validationType: any;
						validationMessage: any;
						isUDF: any;
					}) => {
						const {
							fieldName,
							fieldDesc,
							fieldCode,
							fieldType,
							validationType,
							validationMessage,
							isUDF,
						} = field;
						if (field.fieldCode !== undefined && field.fieldCode !== null) {
							const element = field.fieldCode.toString();
							const elementName = field.fieldName.toString();
							const inputValue = refs[element]?.current || '';
							//const inputValue = handlers[element]?.current;
							const isFieldMandatory = field.isMandatory || false;
							const Message = field.validationMessage || '';
							const IsUDFField = field.isUDF || false;
							vars[element] = inputValue;

							if (field.fieldType === 'Input') {
								return (
									<div
										className="form-group col-lg-4 col-md-6 mb-3"
										key={element.toString()}>
										<label className="" htmlFor={element.toString()}>
											{elementName.toString()}{' '}
											{(isFieldMandatory || validationErrorEU) && (
												<span style={{ color: 'red' }}>*</span>
											)}
										</label>
										<div className="form-group col-lg-12 row">
											<div className="col-12">
												{field.fieldCode === 'phoneNo_Res' ? (
													<>
														<input
															type="text"
															style={{ flex: '1' }}
															className={`form-control px-3 py-2 col-md-8  shadow-sm ${
																validationError && element === errorField
																	? 'is-invalid'
																	: ''
															} `}
															id={element.toString()}
															disabled={disabledFields.includes(
																element.toString()
															)}
															placeholder={placeholderMap[element.toString()]}
															value={inputValue}
															// onKeyUp={(event: BaseSyntheticEvent) => {
															// 	event.target.value = event.target.value.replace(
															// 		/[^0-9]/g,
															// 		''
															// 	);
															// }}
															onKeyUp={(event: BaseSyntheticEvent) => {
																let value = event.target.value;

																// Allow only + at the beginning and digits after that (no spaces)
																value = value.replace(/(?!^\+)[^\d]/g, '');

																// Allow only one + and only at the beginning
																if (value.indexOf('+') > 0) {
																	value = value.replace(/\+/g, '');
																}

																event.target.value = value;
															}}
															onChange={(event) => {
																// setInputValue(element.toString());
																event.target.value = event.target.value.trim();
																const value = event.target.value;
																const error = validateInput(
																	value,
																	element.toString(),
																	isFieldMandatory,
																	validationType,
																	Message,
																	field.fieldType.toString(),
																	IsUDFField
																);

																if (error === undefined || error === null) {
																	//refs[element](value);
																	//refs[element] = value;
																	//refs[element].current = value;
																	handlers[element.toString()](value);

																	setValidationError('');
																} else {
																	//refs[element](value);
																	//refs[element].current = value;
																	handlers[element.toString()](value);

																	setValidationError(error);
																}
															}}
														/>
														{/* <div
															className="col-12"
															style={{ background: 'antiquewhite' }}>
															<i>
																Please provide your phone number in the format
																(XXX)XXXXXXX.
															</i>
														</div> */}
													</>
												) : (
													<>
														<input
															type="text"
															style={{}}
															className={`form-control col-md-12  shadow-sm ${
																validationError && element === errorField
																	? 'is-invalid'
																	: ''
															} `}
															id={element.toString()}
															disabled={disabledFields.includes(
																element.toString()
															)}
															placeholder={placeholderMap[element.toString()]}
															value={inputValue}
															onChange={(event) => {
																event.target.value = event.target.value.trim();
																const value = event.target.value;
																// setInputValue(element.toString());

																const error = validateInput(
																	value,
																	element.toString(),
																	isFieldMandatory,
																	validationType,
																	Message,
																	field.fieldType.toString(),
																	IsUDFField
																);

																if (error === undefined || error === null) {
																	//refs[element](value);
																	//refs[element] = value;
																	//refs[element].current = value;
																	handlers[element.toString()](value);
																	setValidationError('');
																} else {
																	// refs[element] = useRef(value);
																	//refs[element].current = value;
																	handlers[element.toString()](value);

																	//refs[element](value);
																	//refs[element] = value;
																	setValidationError(error);
																}
															}}
														/>
													</>
												)}
											</div>
											<div className="col-12">
												{validationError && element === errorField && (
													<div
														id={'specific' + element.toString()}
														className="invalid-feedback"
														style={{ display: 'block' }}>
														{validationError}
													</div>
												)}
											</div>
										</div>
									</div>
								);
							} else if (
								field.fieldType === 'date' ||
								field.fieldType === 'Date'
							) {
								return (
									<div
										className="form-group col-lg-4 col-md-6 mb-3"
										key={element.toString()}>
										<label className="" htmlFor={element.toString()}>
											{elementName.toString()}{' '}
											{(isFieldMandatory || validationErrorEU) && (
												<span style={{ color: 'red' }}>*</span>
											)}
										</label>
										<div className="form-group col-lg-12 row">
											<div className="col-md-12 ">
												<DatePicker
													id={element.toString()}
													selected={getDateFormatted(vars[element])}
													wrapperClassName={`${styles.datePicker}`}
													value={inputValue}
													onChange={(date) =>
														handleDatePickerChange(
															date,
															element.toString(),
															isFieldMandatory,
															validationType,
															Message,
															field.fieldType.toString()
														)
													}
													className={`form-control px-3 py-2 shadow-sm  ${styles.reactwrapper}`}
													placeholderText="Select date"
												/>
											</div>
											<div className="col-12">
												{validationError && element === errorField && (
													<div
														id={'specific' + element.toString()}
														className="invalid-feedback"
														style={{ display: 'block' }}>
														{validationError}
													</div>
												)}
											</div>
										</div>
									</div>

									// <div
									// 	className="form-group col-lg-4 col-md-6 mb-3"
									// 	key={element.toString()}>
									// 	<label className="px-2" htmlFor={element.toString()}>
									// 		{elementName.toString()}{' '}
									// 		{(isFieldMandatory || validationErrorEU) && (
									// 			<span style={{ color: 'red' }}>*</span>
									// 		)}
									// 	</label>

									// 	<div className="form-group col-lg-12 row">
									// 		<div className="col-6">
									// 			<DatePicker
									// 				id={element.toString()}
									// 				selected={selectedDate}
									// 				wrapperClassName={`${styles.datePicker}`}
									// 				value={formattedDate}
									// 				onChange={(date) =>
									// 					handleDatePickerChange(
									// 						date,
									// 						element.toString(),
									// 						isFieldMandatory,
									// 						validationType,
									// 						Message,
									// 						field.fieldType.toString()
									// 					)
									// 				}
									// 				className={`form-control px-3 py-2 shadow-sm  ${styles.reactwrapper}`}
									// 				placeholderText="Select date"
									// 			/>
									// 		</div>
									// 		<div className="col-12">
									// 			{/* <img
									// 				src={process.env.PUBLIC_URL + '/calendar.svg'}
									// 				alt="calender"
									// 				className=""
									// 				height="50px"
									// 				onClick={handleCalendarIconClick}
									// 			/> */}

									// 			{validationError && element === errorField && (
									// 				<div
									// 					id={'specific' + element.toString()}
									// 					className="invalid-feedback"
									// 					style={{ display: 'block' }}>
									// 					{validationError}
									// 				</div>
									// 			)}
									// 		</div>
									// 	</div>
									// </div>
								);
							} else if (field.fieldType === 'Dropdown') {
								return (
									<div
										className="form-group col-lg-4 col-md-6 mb-3"
										key={element.toString()}>
										<label className="" htmlFor={element.toString()}>
											{elementName.toString()}
										</label>

										<div className="form-group col-lg-12 row">
											<div className="col-md-12 ">
												<Select
													id={element.toString()}
													options={
														element === 'nationality'
															? nationalityCountryRef?.current
															: element === 'countryOfResidence'
															? residenceCountryRef?.current
															: element === 'issueCountry'
															? issueCountryRef?.current
															: []
													}
													onChange={(selectedOption) =>
														handleSelectChange(element, selectedOption)
													}
													// defaultValue={{
													// 	value: refs[element.toString()]?.current,
													// 	label:
													// 		element === 'nationality'
													// 			? nationalityCountryLabelRef?.current
													// 			: element === 'countryOfResidence'
													// 			? residenceCountryLabelRef?.current
													// 			: element === 'issueCountry'
													// 			? issueCountryLabelRef?.current
													// 			: [],
													// }}
													value={{
														value:
															refs[element.toString()]?.current === '' ||
															refs[element.toString()]?.current === '0'
																? ''
																: refs[element.toString()]?.current,
														label:
															element === 'nationality'
																? nationalityCountryLabelRef?.current
																: element === 'countryOfResidence'
																? residenceCountryLabelRef?.current
																: element === 'issueCountry'
																? issueCountryLabelRef?.current
																: [],
													}}
													className="shadow-sm"
													placeholder="Select country"></Select>
											</div>
										</div>
									</div>
								);
							}
						}
					}
				)}

				<div className="form-group col-12">
					<div
						className="fixed-bottom d-flex flex-row justify-content-center button-group pb-4 px-2 border-top gap-4 theme-footer"
						style={{
							backgroundColor: 'white',
							borderColor: 'gray',
						}}>
						{currentProfileIndex > 0 &&
							(skipAccompanyDocument || skipChildDocument) && (
								<>
									<DarkButton text="Skip" onClick={handleSkip} hideArrow />
								</>
							)}

						<DarkButton
							text={t('RegFormButtonNext')}
							onClick={() => {
								// console.log(JSON.stringify(vars));
								handleSubmit(vars);
							}}
							filled
							override={isHideLoader}
							invalidInputs={invalidInputs}
							errorfields={errorfields}
							disabled={invalidInputs}
							validationError={validationError}
						/>
					</div>
				</div>
				{isRefreshLoader === true && (
					<>
						<Modal
							centered
							backdrop={true}
							show={isHideLoader}
							onHide={() => setHideLoader(false)}
							contentClassName="skip-modal-content">
							<Modal.Body>
								<p
									className="p-2 text-center m-0 lh-sm"
									style={{ fontSize: '1rem' }}>
									{t('Please Wait')}
								</p>
								<div
									className="spinner-grow my-auto text-center"
									style={{ margin: 'auto', display: 'flex' }}
									role="status"
								/>
							</Modal.Body>
						</Modal>
					</>
				)}
			</form>
		</div>
	);
};
